/**
 * Sales Closure Constants and Enumerations
 * Defines business modes, payment modes, and commission types for sales closures
 *
 * @module constants/salesClosures
 */

export const BILLING_MODES = {
  FULL_CAMPAIGN_START: 'full_campaign_start_100',
  MONTHLY_PARTIAL_START: 'campaign_start_partial_months',
  FINAL_CAMPAIGN_NO_MONTHLY_CUT: 'campaign_completed_no_monthly_break',
  MONTHLY_CLOSURE: 'monthly_closure'
}

export const BILLING_MODES_LABELS = {
  [BILLING_MODES.FULL_CAMPAIGN_START]: 'Inicio de campaña completo por el 100%',
  [BILLING_MODES.MONTHLY_PARTIAL_START]: 'Inicio de campaña parcial por meses',
  [BILLING_MODES.FINAL_CAMPAIGN_NO_MONTHLY_CUT]: 'Terminada la campaña sin corte mensual',
  [BILLING_MODES.MONTHLY_CLOSURE]: 'Cierre mensual'
}

export const PAYMENT_MODES = {
  PAY_FULL_ODC: 'always_pay_full_po',
  PAY_BY_CONSUMPTION: 'pay_by_consumption'
}

export const PAYMENT_MODES_LABELS = {
  [PAYMENT_MODES.PAY_FULL_ODC]: 'Paga 100% de ODC siempre',
  [PAYMENT_MODES.PAY_BY_CONSUMPTION]: 'Paga por consumo'
}

export const AGENCY_COMMISSION_MODES = {
  PLATFORM_INVOICE_PAYMENT: 'platform_invoice_payment',
  PLATFORM_INVOICE: 'platform_invoice',
  NO_INVOICE: 'no_invoice'
}

export const AGENCY_COMMISSION_MODES_LABELS = {
  [AGENCY_COMMISSION_MODES.PLATFORM_INVOICE_PAYMENT]: 'Factura y pago LatinAd',
  [AGENCY_COMMISSION_MODES.PLATFORM_INVOICE]: 'Factura LatinAd',
  [AGENCY_COMMISSION_MODES.NO_INVOICE]: 'No se factura'
}

export const CLOSURE_STATUS = {
  DRAFT: 'draft',
  VALID: 'valid',
  CANCELED: 'canceled'
}

export const CLOSURE_STATUS_LABELS = {
  [CLOSURE_STATUS.DRAFT]: 'Borrador',
  [CLOSURE_STATUS.VALID]: 'Válido',
  [CLOSURE_STATUS.CANCELED]: 'Anulado'
}

export const CLOSURE_STATUS_COLORS = {
  [CLOSURE_STATUS.DRAFT]: 'warning',
  [CLOSURE_STATUS.VALID]: 'success',
  [CLOSURE_STATUS.CANCELED]: 'danger'
}
